export default __webpack_public_path__ + "static/media/218.715d6705.jpg";